<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        
        
        <Detail :header="header" :values="values" @edit="edit"/>
        <TabMenu :model="nestedRouteItems" />
        <router-view v-if="opportunity" :opportunity="opportunity" />
      </div>
    </div>
      
    <OpportunityForm
      v-if="opportunity && opportunityDialog"
      :key="formKey"
      :opportunityDialog="opportunityDialog"
      :opportunityToEdit="opportunity"
      :disabledArray="disabledArr"
      @close="opportunityDialog = false"
      @save="savedOpportunity"
    />

  </div>
</template>

<script>
import OpportunityService from "@/service/OpportunityService";
import Detail from "@/mbp/universalComponents/Detail.vue";

import OpportunityForm from "@/mbp/universalComponents/opportunity/OpportunityForm.vue";
import BreadcrumbRecordMixin from '../BreadcrumbRecordMixin'
import { FOLLOWUP_EMAILS_ON } from "@/featureFlags";

export default {
  mixins: [BreadcrumbRecordMixin],
  computed: {
    breadcrumbRecordLabel() {
      return this.opportunity && this.opportunity.sQuoteNo ? this.opportunity.sQuoteNo : ''
    }
  },
  components: {
    Detail,
    OpportunityForm
  },
  data() {
    return {
      header: "Enquiry Details",
      opportunityDialog: false,
      nestedRouteItems: [
        {
          label: "Info",
          icon: 'pi pi-info-circle',
          to: `/enquiries/${this.$route.params.custid}/detail`,
        },
        {
          label: "Quotations",
          icon: 'pi pi-money-bill',
          to: `/enquiries/${this.$route.params.custid}/quotations`,
        },
        {
          label: "Tasks & Events",
          icon: 'pi pi-calendar',
          to: `/enquiries/${this.$route.params.custid}/activities`,
        },
        {
          label: "Notes",
          icon: 'pi pi-align-justify',
          to: `/enquiries/${this.$route.params.custid}/notes`,
        },
        {
          label: "Attachments",
          icon: 'pi pi-file',
          to: `/enquiries/${this.$route.params.custid}/attachments`,
        },
        {
          label: "History",
          icon: 'pi pi-inbox',
          to: `/enquiries/${this.$route.params.custid}/history`,
        },
        // Stage 1: no Follow-up tab while the follow-up emails are off (featureFlags.js).
        ...(FOLLOWUP_EMAILS_ON ? [{
          label: "Follow-up",
          icon: 'pi pi-envelope',
          to: `/enquiries/${this.$route.params.custid}/followup`,
        }] : [])
      ],

      opportunity: null,
      // loading1: true,
      // loading2: true,
      address: "",
      values: [],
      disabledArr: [],
      formKey: 10000000
    };
  },
  opportunityService: null,
  created() {
    this.opportunityService = new OpportunityService();
  },
  mounted() {
    this.getOpportunityInfo()
  },
  watch: {
    opportunityDialog(val) {
      if (val) {
        this.formKey++
      }
    },
  },
  methods: {
    getOpportunityInfo() {
      this.opportunityService
        .getOpportunityInfo(this.$route.params.custid)
        .then(data => {
          this.opportunity = data
          this.loading = false
          

          this.values = [
            {
              title: "QuoteNo:",
              description: this.opportunity && this.opportunity.sQuoteNo ? this.opportunity.sQuoteNo : '',
            },
            {
              title: "Enquiry Description:",
              description: this.opportunity && this.opportunity.oppDescription ? this.opportunity.oppDescription : '',
            },
            {
              title: "Status:",
              description: this.opportunity.opportunityStatus,
            },
            null
          ];
        })
        .catch(err => {
          
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting opportunity",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "opportunity/{oppId}"'
          })
        })
    },
    edit() {
      this.disabledArr = [
        // "Description",
        // "Address 1",
        // "Address 2",
        // "Address 3",
        // "City/Town",
        // "Post Code",
        // "Country",
        // "Customer",
        "Date Received",
      ];
      this.opportunityDialog = true;
    },
    savedOpportunity(e) {
      this.loading = true
      this.opportunity = e.opportunity
      this.opportunityDialog = false
      this.getOpportunityInfo()
    }
  }
};
</script>
